import styled from 'styled-components';

export const StyledSection = styled.section`
  margin: 15px 0;
  p,
  div {
    font-weight: 400;
    margin-bottom: 1em;
  }

  b {
    font-weight: 500;
  }

  ul {
    list-style: outside;
    margin-left: 2em;
  }
`;

export const SectionHeader = styled.h2`
  font-weight: 500;
  font-size: 1.5em;
`;
